<template>
  <div class="pt-3">
    <div class="row justify-content-md-center">
      <b-nav class="col-md-12" fill>
        <b-nav-item active>Summary</b-nav-item>
        <b-nav-item ><router-link to="/shipment_md/shipments">Shipments</router-link></b-nav-item>
        <b-nav-item ><router-link to="/shipment_md/orders">Orders</router-link></b-nav-item>
        <b-nav-item v-if="isPrambananConfig"><router-link to="/shipment_md/orders/routing">Order Routing</router-link></b-nav-item>
        <b-nav-item ><router-link to="/location_accuracy">Customer Location Accuracy</router-link></b-nav-item>
        <b-nav-item ><router-link to="/shipment_md/customers">Customers</router-link></b-nav-item>
        <b-nav-item ><router-link to="/shipment_md/locations">Locations</router-link></b-nav-item>
        <b-nav-item ><router-link to="/shipment_md/shipments/completion">Completion</router-link></b-nav-item>
      </b-nav>
    </div>
    <b-row class="mt-4">
      <b-col sm="12" lg="12">
        <div class="box__container--more-2">
          <i class="fa fa-truck fa__bg--red"></i>
          <ul>
            <li>
              <strong>{{ shipment_count_all }}</strong>
              <span>all shipment</span>
            </li>
            <li>
              <strong>{{ shipments_created }}</strong>
              <span>shipments created</span>
            </li>
            <li>
              <strong>{{ shipments_on_process }}</strong>
              <span>shipments on process</span>
            </li>
            <li>
              <strong>{{ shipments_finish }}</strong>
              <span>shipments finish</span>
            </li>
          </ul>
        </div>
      </b-col>
      <!-- <b-col sm="6" lg="6">
        <div class="box__container--more-2">
          <i class="fa fa-cube fa__bg--green"></i>
          <ul>
            <li>
              <strong>{{ order_count_all }}</strong>
              <span>all order</span>
            </li>
            <li>
              <strong>{{ order_unconfirmed }}</strong>
              <span>orders unconfirmed</span>
            </li>
            <li>
              <strong>{{ order_confirmed }}</strong>
              <span>orders confirmed</span>
            </li>
            <li>
              <strong>{{ order_cancelled }}</strong>
              <span>orders cancelled</span>
            </li>
          </ul>
        </div>
      </b-col> -->
      <b-col sm="6" lg="6">
        <div class="box__container--less-2">
          <i class="fa fa-user-o fa__bg--blue"></i>
          <ul>
            <li>
              <strong>{{ count_customer }}</strong>
              <span>all customer</span>
            </li>
            <li>
              <strong>{{ count_customer_active }}</strong>
              <span>customers active</span>
            </li>
          </ul>
        </div>
      </b-col>
      <b-col sm="6" lg="6">
        <div class="box__container--less-2">
          <i class="fa fa-map-o fa__bg--lime"></i>
          <ul>
            <li>
              <strong>{{ location_count_all }}</strong>
              <span>all location</span>
            </li>
          </ul>
        </div>
      </b-col>
    </b-row>
  </div>
</template>
<script>
import { format } from 'date-fns';
import userMixin from './../../../mixins/user';

export default {
  name: 'shipment-summary',
  mixins: [userMixin],
  data() {
    return {
      datacollection: null,
      datasets: [],
    };
  },
  created() {
    this.$store.commit('SET_BREADCRUMB_ITEMS', [
      { to: '', name: 'Home' },
      { to: 'shipment_md', name: 'Shipment MD' },
    ]);
    this.$store.commit('shipment_md/shipments/CLEAR_QUERY');
    this.$store.dispatch('shipment_md/shipments/LOAD_INFO');

    // this.$store.commit('shipment_md/orders/CLEAR_QUERY');
    // this.$store.dispatch('shipment_md/orders/LOAD_INFO');

    this.$store.commit('shipment_md/locations/CLEAR_QUERY');
    this.$store.dispatch('shipment_md/locations/LOAD_INFO');

    this.$store.commit('companies/CLEAR_QUERY');
    this.$store.dispatch('companies/LOAD_INFO');
  },
  computed: {
    shipments() {
      return this.$store.getters['shipment_md/shipments/shipments'];
    },
    shipment_count_all() {
      return this.$store.getters['shipment_md/shipments/count_all'];
    },
    shipments_created() {
      return this.$store.getters['shipment_md/shipments/count_created'];
    },
    shipments_on_process() {
      return this.$store.getters['shipment_md/shipments/count_on_process'];
    },
    shipments_finish() {
      return this.$store.getters['shipment_md/shipments/count_finish'];
    },
    orders() {
      return this.$store.getters['shipment_md/orders/orders'];
    },
    order_count_all() {
      return this.$store.getters['shipment_md/orders/count_all'];
    },
    order_unconfirmed() {
      return this.$store.getters['shipment_md/orders/count_unconfirmed'];
    },
    order_confirmed() {
      return this.$store.getters['shipment_md/orders/count_confirmed'];
    },
    order_cancelled() {
      return this.$store.getters['shipment_md/orders/count_cancelled'];
    },
    location_count_all() {
      return this.$store.getters['shipment_md/locations/count_all'];
    },
    count_customer() {
      return this.$store.getters['companies/count_customer'];
    },
    count_customer_active() {
      return this.$store.getters['companies/count_customer_active'];
    },
    isSystemAdmin() {
      const { userData } = this.$store.getters;
      return userData.type === 'SYSTEM_ADMIN';
    },
  },
  methods: {
    formatDate(date) {
      return format(date, 'D MMM YYYY');
    },
  },
};
</script>

<style lang="sass">
.box__container--more-2,
.box__container--less-2
  min-height: 160px
  margin-bottom: 1.5rem
  text-align: center
  background: #fff
  border: 1px solid #c2cfd6

  &>ul
    padding: 10px 0
    list-style: none

  @for $i from 1 through 4
    li:first-child:nth-last-child(#{$i}),
    li:first-child:nth-last-child(#{$i}) ~ li
      width: 100% / $i;

  &>ul>li
    display: block
    float: left

    &>strong
      display: block
      font-size: 20px

    &>span
      font-size: 10px
      font-weight: 500
      color: #c2cfd6
      text-transform: uppercase

    &:not(:last-child)
      border-right: 1px solid #c2cfd6

  &>i
    display: block
    margin: -1px -1px 0
    font-size: 40px
    line-height: 90px

.fa__bg--blue
  background: #64B5F6

.fa__bg--red
  background: #E57373

.fa__bg--green
  background: #81C784

.fa__bg--lime
  background: #DCE775

@media screen and (max-width: 1024px)
  .box__container--more-2
    min-height: 210px

    @for $i from 1 through 4
      li:first-child:nth-last-child(#{$i}),
      li:first-child:nth-last-child(#{$i}) ~ li
        width: 50%;

      li:nth-child(#{$i})
        @if $i % 2 == 0
          border-right: 0px !important
</style>



// WEBPACK FOOTER //
// src/views/pages/shipment_md/Index.vue